import {
  Accordion,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { ExpandMore } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import {
  FiltersFormCertificate,
  SearchType,
} from 'front-office/pages/released-services/list/types';

interface FiltersCertificateProps {
  filterCertificateForm: FormikProps<FiltersFormCertificate>;
}

const FiltersPersonCertificate = ({
  filterCertificateForm,
}: FiltersCertificateProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (filterCertificateForm.values.searchType === SearchType.Person) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [filterCertificateForm.values.searchType]);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        filterCertificateForm.setValues({
          ...filterCertificateForm.values,
          acronym: '',
          certificateType: '',
          dateFrom: null,
          dateFromVoid: null,
          dateTo: null,
          dateToVoid: null,
          year: '',
          release: undefined,
          payment: '',
          void: '',
          searchType: SearchType.Person,
        });
      }}
    >
      <AccordionSummary
        aria-controls="panel-certificate-content"
        id="panel-certificate-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri di ricerca persona</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form
          onSubmit={filterCertificateForm.handleSubmit}
          onReset={filterCertificateForm.handleReset}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <PmiTextField
                label="Codice fiscale"
                aria-label="Codice fiscale"
                name="fiscalCode"
                id="fiscalCode"
                fullWidth
                value={filterCertificateForm.values.fiscalCode?.toUpperCase() || ''}
                onChange={(event) =>
                  filterCertificateForm.setFieldValue('fiscalCode', event.target.value)
                }
                inputProps={{
                  maxLength: '16',
                }}
                error={
                  !!filterCertificateForm.errors.fiscalCode &&
                  filterCertificateForm.touched.fiscalCode
                }
                helperText={filterCertificateForm.errors.fiscalCode}
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <PmiTextField
                label="Cognome"
                aria-label="Cognome"
                id="surname"
                fullWidth
                value={filterCertificateForm.values.surname || ''}
                onChange={(event) =>
                  filterCertificateForm.setFieldValue('surname', event.target.value)
                }
                error={
                  !!filterCertificateForm.errors.surname && filterCertificateForm.touched.surname
                }
                helperText={filterCertificateForm.errors.surname}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="withoutSurname-replica"
                    checked={filterCertificateForm.values.withoutSurname || false}
                    onChange={() =>
                      filterCertificateForm.setFieldValue(
                        'withoutSurname',
                        !filterCertificateForm.values.withoutSurname
                      )
                    }
                    inputProps={{ 'aria-label': 'Persona senza cognome' }}
                  />
                }
                label="Persona senza cognome"
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <PmiTextField
                label="Nome"
                aria-label="Nome"
                id="name"
                fullWidth
                value={filterCertificateForm.values.name || ''}
                onChange={(event) =>
                  filterCertificateForm.setFieldValue('name', event.target.value)
                }
                error={!!filterCertificateForm.errors.name && filterCertificateForm.touched.name}
                helperText={filterCertificateForm.errors.name}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="withoutName-replica"
                    checked={filterCertificateForm.values.withoutName || false}
                    onChange={() =>
                      filterCertificateForm.setFieldValue(
                        'withoutName',
                        !filterCertificateForm.values.withoutName
                      )
                    }
                    inputProps={{ 'aria-label': 'Persona senza nome' }}
                  />
                }
                label="Persona senza nome"
              />
            </Grid>
            <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
              <Grid item xs={12} md={2}>
                <PmiButton variant="contained" color="secondary" fullWidth type="submit">
                  Cerca
                </PmiButton>
              </Grid>
              <Grid item xs={12} md={2}>
                <PmiButton
                  variant="outlined"
                  color="cdmBrandSecondary"
                  fullWidth
                  onClick={() => {
                    filterCertificateForm.setValues({
                      ...filterCertificateForm.values,
                      fiscalCode: '',
                      name: '',
                      surname: '',
                      withoutName: false,
                      withoutSurname: false,
                      searchType: SearchType.Person,
                    });
                  }}
                >
                  Pulisci
                </PmiButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersPersonCertificate.displayName = 'Filters Person Certificate component';

export default FiltersPersonCertificate;
